import { render, staticRenderFns } from "./VsSimpleUpload.vue?vue&type=template&id=3e9b59d0"
import script from "./VsSimpleUpload.vue?vue&type=script&lang=js"
export * from "./VsSimpleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports